import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePageOne from "./pages/HomePageOne";
import Enquiry from "./pages/Enquiry";
import ErrorPage from "./pages/ErrorPage";
import SignInPage from "./pages/SignInPage";
import Blog from "./pages/BlogPage";
import AddBlogPage from "./pages/AddBlogPage";
import EditBlogPage from "./pages/EditBlogPage";
import ViewBlogPage from "./pages/viewBlog";
import GalleryPage from "./pages/GalleryPage";
import ServicePage from "./pages/ServicePage";
import AddServicePage from "./pages/AddServicePage";
import EditServicePage from "./pages/EditServicePage";
import ViewServicePage from "./pages/ViewServicePage";
import AddGalleryPage from "./pages/AddGalleryPage";
import StaffPage from "./pages/StaffPage";
import AddStaffPage from "./pages/AddStaffPage";
import CustomerPage from "./pages/CustomerPage";
import AddCustomerPage from "./pages/AddCustomerPage";
import EditCustomerPage from "./pages/EditCustomerPage";
import ContentManagementPage from "./pages/ContentManagementPage";
import AddContentPage from "./pages/AddContentPage";
import EditContentPage from "./pages/EditContentPage";
import ProfilePage from "./pages/ProfilePage";
import PricesPage from "./pages/PricesPage";
import AddPricesPage from "./pages/AddPricesPage";
 import OrdersPage from "./pages/OrdersPage";
import ViewOrderPage from "./pages/ViewOrderPage";
import SettingsPage from "./pages/Settings";
import ViewContentPage from "./pages/ViewContentPage";
import Logout from "./pages/Logout";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import AddWorkGalleryPage from "./pages/AddWorkGalleryPage";
import WorkGalleryPage from "./pages/WorkGalleryPage";

import ServiceGalleryPage from "./pages/ServiceGalleryPage";
import AddServiceGalleryPage from "./pages/AddServiceGalleryPage";
import EnrolOrderPage from "./pages/EnrolOrderPage";
import CustomerViewPage from "./pages/CustomerViewPage";

console.log("token", localStorage.getItem('token'));
let activeuser =localStorage.getItem('activeUser');
activeuser =  JSON.parse(activeuser);
 
const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

const PrivateRoute = ({ element }) => {
  return isAuthenticated() ? element : <Navigate to="/" />;
};
const PublicRoute = ({ element }) => {
  return !isAuthenticated() ? element : <Navigate to={'/'+JSON.parse(localStorage.getItem('activeUser')).user_type+"/dashboard"} />;
};


function App() {
 
  return (
    <Router>
      <RouteScrollToTop />
      <Routes>


      <Route exact path='admin/dashboard' element={<PrivateRoute element={<HomePageOne />} />} />
     <Route exact path='subadmin/dashboard' element={<PrivateRoute element={<HomePageOne />} />} />
      <Route exact path='staff/dashboard' element={<PrivateRoute element={<HomePageOne />} />} />
      <Route exact path='customer/dashboard' element={<PrivateRoute element={<HomePageOne />} />} />
      
      <Route exact path='admin/profile' element={<PrivateRoute element={<ProfilePage />} />} />
      <Route exact path='subadmin/profile' element={<PrivateRoute element={<ProfilePage />} />} />
      <Route exact path='staff/profile' element={<PrivateRoute element={<ProfilePage />} />} />
      <Route exact path='customer/profile' element={<PrivateRoute element={<ProfilePage />} />} />
      <Route exact path='admin/customer-view/:id' element={<PrivateRoute element={<CustomerViewPage />} />} />
      
      <Route exact path='admin/settings'  element={<PrivateRoute element={<SettingsPage />} />} />
      
      <Route exact path='admin/enquiry'  element={<PrivateRoute element={<Enquiry />} />} />
       
        <Route exact path='admin/blog'  element={<PrivateRoute  element={<Blog />} />} />
        <Route exact path='admin/blog-add' element={<PrivateRoute  element={<AddBlogPage />} />} />
        <Route exact path='admin/blog-edit/:id' element={<PrivateRoute  element={<EditBlogPage />} />} />
        <Route exact path='admin/blog-view/:id' element={<PrivateRoute  element={<ViewBlogPage />} />} />
      
        <Route exact path='admin/gallery' element={<PrivateRoute  element={<GalleryPage />} />} />
        <Route exact path='admin/gallery-add' element={<PrivateRoute  element={<AddGalleryPage />} />} />
      
        <Route exact path='admin/service' element={<PrivateRoute  element={<ServicePage />} />} />
        <Route exact path='admin/service-add' element={<PrivateRoute  element={<AddServicePage />} />} />
        <Route exact path='admin/service-edit/:id'  element={<PrivateRoute element={<EditServicePage />} />} />
        <Route exact path='admin/service-view/:id' element={<PrivateRoute  element={<ViewServicePage />} />} />
       
        <Route exact path='admin/service-gallery/:service_id' element={<PrivateRoute  element={<ServiceGalleryPage />} />} />
        <Route exact path='admin/add-service-gallery/:serviceid' element={<PrivateRoute  element={<AddServiceGalleryPage />} />} />
       

         
        
        <Route exact path='admin/staff'  element={<PrivateRoute element={<StaffPage />} />} />
        <Route exact path='admin/staff-add'  element={<PrivateRoute element={<AddStaffPage />} />} />
        <Route exact path='admin/staff-edit/:id'  element={<PrivateRoute element={<AddStaffPage />} />} />
        <Route exact path='subadmin/staff'  element={<PrivateRoute element={<StaffPage />} />} />
        <Route exact path='subadmin/staff-add'  element={<PrivateRoute element={<AddStaffPage />} />} />
        <Route exact path='subadmin/staff-edit/:id'  element={<PrivateRoute element={<AddStaffPage />} />} />

        <Route exact path='admin/customer'  element={<PrivateRoute element={<CustomerPage />} />} />
        <Route exact path='admin/customer-add'  element={<PrivateRoute element={<AddCustomerPage />} />} />
        <Route exact path='admin/customer-edit/:id'  element={<PrivateRoute element={<AddCustomerPage />} />} />
        <Route exact path='subadmin/customer'  element={<PrivateRoute element={<CustomerPage />} />} />
        <Route exact path='subadmin/customer-add'  element={<PrivateRoute element={<AddCustomerPage />} />} />
        <Route exact path='subadmin/customer-edit/:id'  element={<PrivateRoute element={<AddCustomerPage />} />} />

        <Route exact path='staff/customer'  element={<PrivateRoute element={<CustomerPage />} />} />
        <Route exact path='staff/customer-add'  element={<PrivateRoute element={<AddCustomerPage />} />} />
        <Route exact path='staff/customer-edit/:id'  element={<PrivateRoute element={<AddCustomerPage />} />} />
       
        <Route exact path='admin/content-management'  element={<PrivateRoute element={<ContentManagementPage />} />} />
        <Route exact path='admin/add-content'  element={<PrivateRoute element={<AddContentPage />} />} />
        <Route exact path='admin/edit-content/:id'  element={<PrivateRoute element={<EditContentPage />} />} />
        <Route exact path='admin/view-content/:id'  element={<PrivateRoute element={<ViewContentPage />} />} />
       
        <Route exact path='admin/price-management'  element={<PrivateRoute element={<PricesPage />} />} />
        <Route exact path='admin/add-price'  element={<PrivateRoute element={<AddPricesPage />} />} />
        <Route exact path='admin/price-edit/:id'  element={<PrivateRoute element={<AddPricesPage />} />} />
         
        <Route exact path='admin/enroll-order'  element={<PrivateRoute element={<EnrolOrderPage />} />} />
        <Route exact path='admin/orders'  element={<PrivateRoute element={<OrdersPage />} />} />
        <Route exact path='admin/order-view/:id'  element={<PrivateRoute element={<ViewOrderPage />} />} />
        <Route exact path='subadmin/enroll-order'  element={<PrivateRoute element={<EnrolOrderPage />} />} />
        <Route exact path='subadmin/orders'  element={<PrivateRoute element={<OrdersPage />} />} />
        <Route exact path='subadmin/order-view/:id'  element={<PrivateRoute element={<ViewOrderPage />} />} />
      
        <Route exact path='admin/work-gallery-add'  element={<PrivateRoute element={<AddWorkGalleryPage />} />} />
        <Route exact path='admin/work-gallery-list'  element={<PrivateRoute element={<WorkGalleryPage />} />} />
      

         
         <Route exact path='staff/enroll-order'  element={<PrivateRoute element={<EnrolOrderPage />} />} />
         <Route exact path='staff/orders'  element={<PrivateRoute element={<OrdersPage />} />} />
         <Route exact path='staff/order-view/:id'  element={<PrivateRoute element={<ViewOrderPage />} />} />
    
         <Route exact path='customer/orders'  element={<PrivateRoute element={<OrdersPage />} />} />
         <Route exact path='customer/order-view/:id'  element={<PrivateRoute element={<ViewOrderPage />} />} />
        
        <Route exact path='/' element={<PublicRoute  element={<SignInPage />} />} />
        <Route exact path='/logout' element={<Logout />} />
        <Route exact path='*' element={<ErrorPage />} />
        </Routes>
     
    </Router>
  );
}

export default App;
